const INITIAL_STATE = { leaderBoardData: [], imageList: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'FETCH_LEADERBOARD_LIST':
            return { ...state };
        case 'FETCH_LEADERBOARD_LIST_SUCCESS':
            return { ...state, leaderBoardData: action.payload };
        case 'FETCH_LEADERBOARD_LIST_FAIL':
            return { ...state };
        case 'FETCH_IMAGES':
            return { ...state };
        case 'FETCH_IMAGES_SUCCESS':
            return { ...state, imageList: action.payload };
        case 'FETCH_IMAGES_FAIL':
            return { ...state };
        case 'IMAGE_SELECTION':
            return { ...state, selectedImage: action.payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/LeaderBoard/LeaderBoardReducer.js